<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header Section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div class="d-flex align-items-center">
              <button class="btn btn-icon me-3 border" routerLink="/expenses/travel-reports">
                <i class="bi bi-arrow-left"></i>
              </button>
              <div>
                <h1 class="card-title mb-1">
                  @if (employee) {
                    {{ employee.user.first_name }} {{ employee.user.last_name }}'s Travel Logs
                  } @else {
                    Travel Logs
                  }
                </h1>
                <span class="sub-text">Daily odometer readings and travel route records</span>
              </div>
            </div>

            <div class="mt-2 mt-md-0">
              <button class="btn btn-soft-primary d-flex align-items-center gap-2" (click)="openDownloadModal()">
                <i class="bi bi-download"></i>
                <span>Download Travel Reports</span>
              </button>
            </div>
          </div>

          <!-- Travel Log Filters -->
          <div class="bg-light p-3 border mb-4">
            <div class="row g-3 align-items-start">
              <div class="col-md-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Filter By</label>
                <ng-select
                  [items]="logFilterModes"
                  [(ngModel)]="logFilterMode"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="false"
                  [searchable]="false"
                  (ngModelChange)="onLogFilterModeChange()" />
              </div>

              @if (logFilterMode === 'date') {
                <div class="col-md-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Date</label>
                  <input type="date" class="form-control" [(ngModel)]="logFilters.date" />
                </div>
              }

              @if (logFilterMode === 'range') {
                <div class="col-md-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Start Date</label>
                  <input type="date" class="form-control" [(ngModel)]="logFilters.start_date" />
                </div>

                <div class="col-md-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">End Date</label>
                  <input
                    type="date"
                    class="form-control"
                    [(ngModel)]="logFilters.end_date"
                    [min]="logFilters.start_date || null" />
                </div>
              }

              @if (logFilterMode === 'month') {
                <div class="col-md-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Month</label>
                  <ng-select
                    placeholder="Select month"
                    [items]="monthOptions"
                    [(ngModel)]="logFilters.month"
                    bindValue="value"
                    bindLabel="label"
                    [clearable]="false"
                    [searchable]="false" />
                </div>
              }

              @if (logFilterMode === 'month' || logFilterMode === 'year') {
                <div class="col-md-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Year</label>
                  <input type="number" class="form-control" [(ngModel)]="logFilters.year" [min]="2020" [max]="2100" />
                </div>
              }

              @if (logFilterMode !== 'all') {
                <div class="col-md-3 d-flex align-items-end gap-2" style="padding-top: 1.6rem">
                  <button
                    class="btn btn-soft-primary btn-sm"
                    (click)="onApplyLogFilters()"
                    [disabled]="isLoading || !!logFilterError">
                    <i class="bi bi-funnel"></i>
                    Apply
                  </button>
                  <button class="btn btn-soft-secondary btn-sm" (click)="onClearLogFilters()">
                    <i class="bi bi-x-circle"></i>
                    Clear
                  </button>
                </div>
              }
            </div>

            @if (logFilterError) {
              <div class="text-danger small mt-2">{{ logFilterError }}</div>
            }
          </div>

          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            @if ((logs || []).length === 0) {
              <div class="empty-state-container my-5">
                <i class="bi bi-map"></i>
                <h5 class="text-dark fw-bold">No Travel Logs Found</h5>
                <p class="text-muted">
                  @if (logFilterMode === 'all') {
                    No travel records found for this employee.
                  } @else {
                    No travel records found for the selected period.
                  }
                </p>
              </div>
            } @else {
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-4 border-0 text-uppercase small fw-bold text-muted py-3">Date</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Route</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Opening KM</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Closing KM</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Total KM</th>
                      <th class="pe-4 border-0 text-uppercase small fw-bold text-muted py-3 text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (log of logs; track log.id) {
                      <tr class="border-bottom">
                        <td class="ps-4 py-3">
                          <span class="text-muted small">
                            <i class="bi bi-calendar-event me-1"></i>
                            {{ log.date | date: 'dd MMM yyyy' }}
                          </span>
                        </td>
                        <td class="py-3">
                          <span class="app-badge badge-primary">{{ log.route | titlecase }}</span>
                        </td>
                        <td class="py-3">
                          <span class="fw-semibold text-dark">{{ log.opening_km ?? '-' }} km</span>
                        </td>
                        <td class="py-3">
                          <span class="fw-semibold text-dark">{{ log.closing_km ?? '-' }} km</span>
                        </td>
                        <td class="py-3">
                          @if (log.total_km > 0) {
                            <span class="app-badge badge-success">{{ log.total_km }} km</span>
                          } @else {
                            <span class="app-badge badge-warning">Incomplete</span>
                          }
                        </td>
                        <td class="pe-4 py-3 text-end">
                          <button class="btn btn-action-info" (click)="viewLogDetail(log)" title="View Details">
                            <i class="bi bi-eye"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="mt-4">
                <app-pagination
                  [currentPage]="currentPage"
                  [totalCount]="totalCount"
                  [pageSize]="10"
                  [hasNextPage]="hasNextPage"
                  [hasPreviousPage]="hasPreviousPage"
                  (pageChange)="onPageChange($event)"></app-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Download Report Modal -->
<ng-template #downloadReportModal let-modal>
  <div class="modal-content border-0 overflow-hidden">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold">Download Travel Report</h5>
        <div class="text-muted small">
          @if (employee) {
            {{ employee.user.first_name }} {{ employee.user.last_name }}
          }
        </div>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body p-4">
      <!-- Mode toggle -->
      <div class="d-flex gap-3 mb-4 flex-wrap">
        <div class="form-check">
          <input class="form-check-input" type="radio" id="dlModeMonth" [(ngModel)]="logReportMode" value="month" />
          <label class="form-check-label small" for="dlModeMonth">Month</label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="dlModeMonthRange"
            [(ngModel)]="logReportMode"
            value="month_range" />
          <label class="form-check-label small" for="dlModeMonthRange">Month Range</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="dlModeYear" [(ngModel)]="logReportMode" value="year" />
          <label class="form-check-label small" for="dlModeYear">Full Year</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="dlModeRange" [(ngModel)]="logReportMode" value="range" />
          <label class="form-check-label small" for="dlModeRange">Date Range</label>
        </div>
      </div>

      @if (logReportMode === 'month') {
        <div class="row g-3">
          <div class="col-6">
            <label class="form-label small fw-bold text-muted text-uppercase">Year</label>
            <input type="number" class="form-control" [(ngModel)]="logReportFilters.year" [min]="2020" [max]="2100" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold text-muted text-uppercase">Month</label>
            <ng-select
              [items]="monthOptions"
              [(ngModel)]="logReportFilters.month"
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false" />
          </div>
        </div>
      } @else if (logReportMode === 'month_range') {
        <div class="mb-3">
          <label class="form-label small fw-bold text-muted text-uppercase">Year</label>
          <input type="number" class="form-control" [(ngModel)]="logReportFilters.year" [min]="2020" [max]="2100" />
        </div>
        <div class="row g-3">
          <div class="col-6">
            <label class="form-label small fw-bold text-muted text-uppercase">From Month</label>
            <ng-select
              [items]="monthOptions"
              [(ngModel)]="logReportFilters.start_month"
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold text-muted text-uppercase">To Month</label>
            <ng-select
              [items]="monthOptions"
              [(ngModel)]="logReportFilters.end_month"
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false" />
          </div>
        </div>
      } @else if (logReportMode === 'year') {
        <div class="mb-3">
          <label class="form-label small fw-bold text-muted text-uppercase">Year</label>
          <input type="number" class="form-control" [(ngModel)]="logReportFilters.year" [min]="2020" [max]="2100" />
        </div>
      } @else {
        <div class="mb-3">
          <label class="form-label small fw-bold text-muted text-uppercase">Start Date</label>
          <input type="date" class="form-control" [(ngModel)]="logReportFilters.start_date" />
        </div>
        <div class="mb-3">
          <label class="form-label small fw-bold text-muted text-uppercase">End Date</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="logReportFilters.end_date"
            [min]="logReportFilters.start_date" />
        </div>
      }
    </div>

    <div class="modal-footer p-3">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="onDownloadReport()" [disabled]="isDownloadDisabled()">
        @if (isDownloading) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Downloading...
        } @else {
          <i class="bi bi-download"></i>
          Download
        }
      </button>
    </div>
  </div>
</ng-template>

<!-- Log Detail Modal -->
<ng-template #logDetailModal let-modal>
  <div class="modal-content border-0 overflow-hidden">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold">Travel Log Details</h5>
        <div class="text-muted small">
          <i class="bi bi-calendar-event me-1"></i>
          {{ selectedLog?.date | date: 'fullDate' }}
        </div>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <!-- Info Section -->
      <div class="bg-light p-4 border mb-4">
        <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-4">Trip Information</h6>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Route</span>
              <span class="app-badge badge-primary">{{ selectedLog?.route | titlecase }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Total Distance</span>
              @if ((selectedLog?.total_km ?? 0) > 0) {
                <span class="fw-bold text-success">{{ selectedLog?.total_km }} km</span>
              } @else {
                <span class="app-badge badge-warning">Incomplete</span>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Opening KM</span>
              <span class="fw-bold text-dark">{{ selectedLog?.opening_km ?? '-' }} km</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Closing KM</span>
              <span class="fw-bold text-dark">{{ selectedLog?.closing_km ?? '-' }} km</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Meter Images -->
      <div class="row g-4">
        <div class="col-md-6">
          <div class="border bg-light p-3 h-100 d-flex flex-column">
            <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-3">Opening Meter</h6>
            @if (selectedLog?.opening_meter_image) {
              <img
                [src]="selectedLog?.opening_meter_image"
                alt="Opening Meter"
                class="img-fluid rounded border shadow-sm"
                style="max-height: 250px; object-fit: contain" />
            } @else {
              <div
                class="d-flex flex-column align-items-center justify-content-center flex-grow-1 text-muted opacity-50 py-4">
                <i class="bi bi-image fs-1 d-block mb-2"></i>
                <p class="small fw-bold mb-0">No image attached</p>
              </div>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="border bg-light p-3 h-100 d-flex flex-column">
            <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-3">Closing Meter</h6>
            @if (selectedLog?.closing_meter_image) {
              <img
                [src]="selectedLog?.closing_meter_image"
                alt="Closing Meter"
                class="img-fluid rounded border shadow-sm"
                style="max-height: 250px; object-fit: contain" />
            } @else {
              <div
                class="d-flex flex-column align-items-center justify-content-center flex-grow-1 text-muted opacity-50 py-4">
                <i class="bi bi-image fs-1 d-block mb-2"></i>
                <p class="small fw-bold mb-0">No image attached</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer p-3">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
  </div>
</ng-template>
